module.exports = __webpack_public_path__ + "img/clouds_1.6c2ce0ff.png";